export default "__VITE_ASSET__ByjrKvtn__"